import { apiInstance } from '@/api/instance';
import { partnersApiKeys, type PartnerMemberRole } from '@/api/routes/partners/partners.api';

/** Contract: bodyprint-api/docs/external-apis/partners-contract.md (Membros). Managing them is owner-only. */
export type PartnerInvitableRole = Exclude<PartnerMemberRole, 'owner'>;

export interface PartnerMember {
  userId: string;
  firstName: string;
  lastName: string | null;
  email: string;
  role: PartnerMemberRole;
  createdAt: string;
}

export interface PartnerMemberInvite {
  id: string;
  email: string;
  role: PartnerMemberRole;
  expiresAt: string;
  createdAt: string;
}

export interface PartnerMembersResponse {
  /** The owner first, then by arrival. */
  members: PartnerMember[];
  /** Open invites only (not accepted, not expired), newest first. */
  invites: PartnerMemberInvite[];
}

export interface PartnerMemberInviteRequest {
  email: string;
  role: PartnerInvitableRole;
}

export interface PartnerMemberInviteResponse {
  invite: PartnerMemberInvite;
  /** The link the e-mail carries, so the owner can also share it by hand. */
  inviteUrl: string;
}

export const partnersMembersApi = {
  list: () => apiInstance.get<PartnerMembersResponse>('partners/members'),
  invite: (data: PartnerMemberInviteRequest) =>
    apiInstance.post<PartnerMemberInviteResponse>('partners/members/invites', data),
  revokeInvite: (inviteId: string) =>
    apiInstance.delete<void>(`partners/members/invites/${inviteId}`),
  remove: (userId: string) => apiInstance.delete<void>(`partners/members/${userId}`),
};

/** Under `partnersApiKeys.all`, so editing the account also refreshes the members. */
export const partnersMembersApiKeys = {
  all: [...partnersApiKeys.all, 'members'] as const,
};
